import { PaletteTheme } from '@kite-js/theme-types';
import colors from '../colors';

type CorePalette = Pick<
    PaletteTheme,
    'primary' | 'secondary' | 'darkmode' | 'disable' | 'price' | 'background' | 'text' | 'dim'
>;

const corePalette: CorePalette = {
    primary: {
        darkSolid: {
            background: colors.orange[500],
            text: colors.white,
        },
        solid: {
            background: colors.orange[300],
            text: colors.white,
        },
        light: {
            background: colors.orange[50],
            text: colors.orange[300],
        },
        bordered: {
            background: colors.white,
            border: colors.orange[300],
            text: colors.orange[300],
        },
        plainText: {
            text: colors.orange[300],
        },
    },
    secondary: {
        darkSolid: {
            background: colors.background[800],
            text: colors.white,
        },
        solid: {
            background: colors.background[300],
            text: colors.white,
        },
        light: {
            background: colors.background[20],
            text: colors.text[500],
        },
        bordered: {
            background: colors.white,
            border: colors.background[50],
            text: colors.text[800],
        },
        plainText: {
            text: colors.orange[400],
        },
    },
    darkmode: {
        darkSolid: {
            background: colors.background[800],
            text: colors.white,
        },
        solid: {
            background: colors.background[300],
            text: colors.white,
        },
        light: {
            background: colors.white,
            text: colors.text[800],
        },
        bordered: {
            background: colors.white,
            border: colors.background[800],
            text: colors.text[800],
        },
        plainText: {
            text: colors.text[800],
        },
        gradient: {
            backgroundStart: colors.background[300],
            backgroundEnd: colors.background[800],
            text: colors.white,
        },
    },
    disable: {
        darkSolid: {
            background: colors.background[200],
            text: colors.text[300],
        },
        solid: {
            background: colors.background[50],
            text: colors.text[300],
        },
        light: {
            background: colors.background[50],
            text: colors.text[300],
        },
        bordered: {
            background: colors.white,
            border: colors.background[50],
            text: colors.text[300],
        },
        plainText: {
            text: colors.text[300],
        },
        gradient: {
            backgroundStart: colors.background[150],
            backgroundEnd: colors.background[150],
            text: colors.white,
        },
    },
    price: {
        darkSolid: {
            background: colors.background[800],
            text: colors.white,
        },
        solid: {
            background: colors.background[800],
            text: colors.white,
        },
        light: {
            background: colors.background[800],
            text: colors.white,
        },
        bordered: {
            background: colors.white,
            border: colors.text[800],
            text: colors.text[800],
        },
        plainText: {
            text: colors.text[800],
        },
        gradient: {
            backgroundStart: colors.red[300],
            backgroundEnd: colors.red[200],
            text: colors.white,
        },
    },
    background: {
        0: colors.white,
        gradient: {
            start: '',
            end: '',
        },
        ...colors.background,
    },
    text: {
        0: colors.white,
        inherit: 'inherit',
        ...colors.text,
    },
    dim: {
        pressState: colors.alpha[150],
        modal: colors.alpha[200],
        coachmark: colors.alpha[800],
        navigationTab: colors.alpha[200],
        hoverState: colors.alpha[300],
    },
};

export default corePalette;
